import { UrgencyIdField, RadioButtonField, PrecautionFields } from '~fields';
import RoomFields from './RoomFields';

const PatientBedFields = props => (
  <>
    <RoomFields {...props} />

    <UrgencyIdField name="urgency" required />

    <PrecautionFields {...props} />

    <RadioButtonField name="plasticWrap" flat firstElementMinWidth="150px" />
  </>
);

export default PatientBedFields;
